import { RendererFactory } from "survey-core";

export const registerRenderers = () => {
  RendererFactory.Instance.registerRenderer("text", "input", "input", true);
  RendererFactory.Instance.registerRenderer(
    "comment",
    "textarea",
    "textarea",
    true,
  );
  RendererFactory.Instance.registerRenderer(
    "dropdown",
    "select",
    "select",
    true,
  );
  RendererFactory.Instance.registerRenderer(
    "radiogroup",
    "radio",
    "radio",
    true,
  );
};
